import { render, staticRenderFns } from "./PhoneInfo.vue?vue&type=template&id=04395110&scoped=true&"
import script from "./PhoneInfo.vue?vue&type=script&lang=js&"
export * from "./PhoneInfo.vue?vue&type=script&lang=js&"
import style0 from "./PhoneInfo.vue?vue&type=style&index=0&id=04395110&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04395110",
  null
  
)

export default component.exports